module.exports = __webpack_public_path__ + "static/img/satanizador-4.1ec5992.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/satanizador-4.jpg
// module id = 7wDT
// module chunks = 1